import React, { FC, useContext, useState } from 'react';
import { ModalHeader } from '../../components/form/ModalHeader';
import { useTranslation } from 'react-i18next';
import { Form, Modal } from 'react-bootstrap';
import { DashboardDialogsAssetsSelect } from './DashboardDialogsAssetsSelect';
import { DashboardDialogsSiteSelect } from './DashboardDialogsSiteSelect';
import { FormModalFooter } from '../../components/form/FormModalFooter';
import { DashboardDialogAssetsRequestPayloadFactory } from './DashboardDialogAssetsRequestPayloadFactory';
import { DashboardDialogSelectOption } from './types/DashboardDialogSelectOption';
import toast from 'react-hot-toast';
import { api } from '../../functions/api';
import { ApiPath } from '../../api/ApiPath';
import ModalContext from 'react-bootstrap/ModalContext';
import { useSavingToastMessages } from '../../hooks/useSavingToastMessages';
import { FormSelectOption } from '../../components/form/FormSelect';
import { Site } from '../../sites/dto/Site';

export const DashboardTransferDialog: FC = () => {
  const { t } = useTranslation();
  const [assets, setAssets] = useState<DashboardDialogSelectOption[]>([]);
  const [sourceSite, setSourceSite] = useState<FormSelectOption<Site> | null>(null);
  const [destinationSite, setDestinationSite] = useState<FormSelectOption<Site> | null>(null);
  const { onHide } = useContext(ModalContext);
  const messages = useSavingToastMessages();

  const canSubmit = assets.length > 0 && sourceSite && destinationSite && sourceSite.value.id !== destinationSite.value.id;

  return (
    <>
      <ModalHeader>{t('Transfer assets between sites')}</ModalHeader>

      <form
        onSubmit={async (event) => {
          event.preventDefault();

          if (canSubmit) {
            const payload = new DashboardDialogAssetsRequestPayloadFactory(assets).getRequestPayload();

            await toast.promise(
              api({
                method: 'post',
                url: ApiPath.DashboardTransfers,
                data: {
                  assetIds: payload.assetIds,
                  sourceSiteId: sourceSite.value.id,
                  destinationSiteId: destinationSite.value.id,
                },
              }),
              messages,
            );

            onHide();
          }
        }}
      >
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>{t('Source site')}</Form.Label>
            <DashboardDialogsSiteSelect
              onChange={setSourceSite}
              value={sourceSite}
              placeholder={t('Select source site').toString()}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t('Destination site')}</Form.Label>
            <DashboardDialogsSiteSelect
              onChange={setDestinationSite}
              value={destinationSite}
              placeholder={t('Select destination site').toString()}
              excludeSiteId={sourceSite?.value.id}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t('Assets to transfer')}</Form.Label>
            <DashboardDialogsAssetsSelect onChange={setAssets} />
          </Form.Group>
        </Modal.Body>

        <FormModalFooter disabled={!canSubmit} />
      </form>
    </>
  );
};
